import MoodHighestIcon from "../../atoms/MoodHighestIcon"
import MoodLowestIcon from "../../atoms/MoodLowestIcon"
import MoodNormalIcon from "../../atoms/MoodNormalIcon"

interface CustomLabelProps {
  x?: number
  y?: number
  index?: number
}

/** A small label component used by the enjoyment chart to populate y-axis ticks.
 * Generates icons for different enjoyment scores
 * @param {CustomLabelProps} tick - A tick mark for a chart
 */
export default function EnjoymentChartLabel(tick: CustomLabelProps) {
  const x = tick?.x ? tick.x - 20 : 0
  const y = tick?.y ? tick.y - 10 : 0
  return (
    <g>
      {tick.index === 0 ? (
        <MoodLowestIcon x={x} y={y} />
      ) : tick.index === 2 ? (
        <MoodNormalIcon x={x} y={y} />
      ) : tick.index === 4 ? (
        <MoodHighestIcon x={x} y={y} />
      ) : null}
    </g>
  )
}
